export default __webpack_public_path__ + "static/media/aesliari-01.02470a43.png";